<template>
  <div :class="disableBtn && currentStep === 0 ? 'container-dynamic-form-detail' : 'container-dynamic-form'">
    <div v-for="element in getCurrentStep" v-bind:key="uniqueId('root')"
      :class="element.styles + `${verifyConditions(element) ? '' : ' d-none'}`">
      <h1 v-if="verifyConditions(element) && element.type === 'title'" class="text-[#5C5C5C]">
        {{ element.title }}
      </h1>

      <h2 v-if="verifyConditions(element) && element.type === 'subtitle'" class="mt-10  w-max text-[#5C5C5C]">
        {{ element.title }}
      </h2>

      <BaseInput v-if="verifyConditions(element) && element.type === 'inputText'" :label="element.title"
        :value="FormData[element.keyVariable]" :numeric="element.typeInput === 'number'"
        @input="(value) => onInput(element.keyVariable, value)" @blur="(e, val) => onBlur(e, val, element.keyVariable)"
        :disabled="disableBtn ? true : element.disabled" :required="element.required" :ref="element.keyVariable" />

      <BaseInput v-if="verifyConditions(element) && element.type === 'inputDate'" :label="element.title"
        v-model="FormData[element.keyVariable]"
        :disabled="disableBtn ? true : element.idHide !== '' ? !!openAccord[element.keyVariable] : element.disabled"
        :required="element.required" type="date" :ref="element.keyVariable" />

      <BaseTextarea v-if="verifyConditions(element) && element.type === 'textArea'" :label="element.title"
        :value="FormData[element.keyVariable]" :disabled="disableBtn ? true : element.disabled"
        @input="(value) => onInput(element.keyVariable, value)" :required="element.required"
        :maxlength="element.maxlength" :ref="element.keyVariable" />

      <BaseSelect v-if="verifyConditions(element) && element.type === 'inputSelect'" :label="element.title"
        v-model="FormData[element.keyVariable]" :disabled="disableBtn ? true : element.disabled"
        @change="(value) => onChangeSelect(element.onChange, value)" :required="element.required"
        :selectOptions="getOptions(element.selectOptions)" :id="element.keyVariable" :ref="element.keyVariable" />

      <BaseRadio v-if="verifyConditions(element) && element.type === 'inputOption'" :label="element.title"
        v-model="FormData[element.keyVariable]" :disabled="disableBtn ? true : element.disabled"
        :required="element.required" :radioOptions="getOptions(element.radioOptions)" :ref="element.keyVariable"
        :onChangeValue="onChangeRadio(element)" />

      <DragDrop v-if="verifyConditions(element) && element.type === 'inputFile'" :label="element.title"
        buttonLabel="SELECCIONE SUS ARCHIVOS" :disabled="disableBtn"
        :fileList="FormData[element.keyVariable] != null ? FormData[element.keyVariable] : []" :id="element.keyVariable"
        v-model="FormData[element.keyVariable]" @files-handler="setFiles($event, element.keyVariable)" maxMB="20"
        :ref="element.keyVariable" />

      <Accordion :open="element.idHide !== '' ? !!openAccord[element.keyVariable] : true"
        :disable="element.idHide === '' ? false : !openAccord[element.keyVariable]" :key="element.keyVariable"
        v-if="verifyConditions(element) && element.type === 'accordion'" :header="element.title"
        :isDelete="element.isDelete" @deletecomponent="deleteComponent(element)">

        <div v-for="element2 in element.contentAccordion" v-bind:key="uniqueId('root-accordion')" :class="element2.styles"
          :ref="element.keyVariable">

          <h1 v-if="verifyConditions(element2) && element2.type === 'title'" class="text-[#5C5C5C]">
            {{ element2.title }}
          </h1>

          <h2 v-if="verifyConditions(element2) && element2.type === 'subtitle'" class="mt-10  w-max text-[#5C5C5C]">
            {{ element2.title }}
          </h2>

          <BaseInput v-if="verifyConditions(element2) && element2.type === 'inputText'" :label="element2.title"
            :value="FormData[element2.keyVariable]" @input="(value) => onInput(element2.keyVariable, value)"
            @blur="(e, val) => onBlur(e, val, element2.keyVariable)" :disabled="disableBtn ? true : element2.disabled"
            :numeric="element2.typeInput === 'number'" :required="element2.required" :ref="element2.keyVariable" />

          <BaseInput v-if="verifyConditions(element2) && element2.type === 'inputDate'" :label="element2.title"
            v-model="FormData[element2.keyVariable]" :disabled="disableBtn ? true : element2.disabled"
            :required="element2.required" type="date" :ref="element2.keyVariable" />

          <BaseTextarea v-if="verifyConditions(element2) && element2.type === 'textArea'" :label="element2.title"
            :value="FormData[element2.keyVariable]" @input="(value) => onInput(element2.keyVariable, value)"
            :disabled="disableBtn ? true : element2.disabled" :required="element2.required"
            :maxlength="element2.maxlength" :ref="element2.keyVariable" />

          <BaseSelect v-if="verifyConditions(element2) && element2.type === 'inputSelect'" :label="element2.title"
            v-model="FormData[element2.keyVariable]" :disabled="disableBtn ? true : element2.disabled"
            @change="(value) => onChangeSelect(element2.onChange, value)" :required="element2.required"
            :selectOptions="getOptions(element2.selectOptions)" :id="element.keyVariable" :ref="element2.keyVariable" />

          <BaseRadio v-if="verifyConditions(element2) && element2.type === 'inputOption'" :label="element2.title"
            v-model="FormData[element2.keyVariable]" :disabled="disableBtn ? true : element2.disabled"
            :required="element2.required" :radioOptions="getOptions(element2.radioOptions)"
            :onChangeValue="onChangeRadio(element2)" :ref="element2.keyVariable" />

          <DragDrop v-if="verifyConditions(element2) && element2.type === 'inputFile'" :label="element2.title"
            buttonLabel="SELECCIONE SUS ARCHIVOS"
            :fileList="FormData[element2.keyVariable] != null ? FormData[element2.keyVariable] : []"
            :id="element2.keyVariable" v-model="FormData[element2.keyVariable]" :disabled="disableBtn"
            @files-handler="setFiles($event, element2.keyVariable)" maxMB="20" :ref="element2.keyVariable" />

          <Accordion v-if="verifyConditions(element2) && element2.type === 'accordion'" :key="element2.keyVariable"
            :open="element2.idHide !== '' ? !!openAccord[element2.keyVariable] : true"
            :disable="element2.idHide === '' ? false : !openAccord[element2.keyVariable]" :header="element2.title"
            :ref="element2.keyVariable" :isDelete="element2.isDelete" @deletecomponent="deleteComponent(element2)">

            <div v-for="element3 in element2.contentAccordion" v-bind:key="uniqueId('root-accordion-sub')"
              :class="element3.styles">
              <h1 v-if="verifyConditions(element3) && element3.type === 'title'" class="text-[#5C5C5C]">
                {{ element3.title }}
              </h1>

              <h2 v-if="verifyConditions(element3) && element3.type === 'subtitle'
                " class="mt-10 w-max text-[#5C5C5C]">
                {{ element3.title }}
              </h2>

              <BaseInput v-if="element3.type === 'inputText'
                " :label="element3.title" :numeric="element3.typeInput === 'number'"
                :value="FormData[element3.keyVariable]" @input="(value) => onInput(element3.keyVariable, value)"
                @blur="(e, val) => onBlur(e, val, element3.keyVariable)" :disabled="disableBtn ? true : element3.disabled"
                :required="element3.required" :ref="element3.keyVariable" />

              <BaseInput v-if="verifyConditions(element3) && element3.type === 'inputDate'
                " :label="element3.title" v-model="FormData[element3.keyVariable]"
                :disabled="disableBtn ? true : element3.disabled" :required="element3.required" type="date"
                :ref="element3.keyVariable" />

              <BaseTextarea v-if="verifyConditions(element3) && element3.type === 'textArea'
                " :label="element3.title" :value="FormData[element3.keyVariable]"
                @input="(value) => onInput(element3.keyVariable, value)" :disabled="disableBtn ? true : element3.disabled"
                :required="element3.required" :maxlength="element3.maxlength" :ref="element3.keyVariable" />

              <BaseSelect v-if="verifyConditions(element3) && element3.type === 'inputSelect'
                " :label="element3.title" v-model="FormData[element3.keyVariable]"
                :disabled="disableBtn ? true : element3.disabled" :required="element3.required"
                @change="(value) => onChangeSelect(element3.onChange, value)"
                :selectOptions="getOptions(element3.selectOptions)" :ref="element3.keyVariable" />

              <BaseRadio v-if="verifyConditions(element3) && element3.type === 'inputOption'
                " :label="element3.title" v-model="FormData[element3.keyVariable]"
                :disabled="disableBtn ? true : element3.disabled" :required="element3.required"
                :radioOptions="getOptions(element3.radioOptions)" :ref="element3.keyVariable"
                :onChangeValue="onChangeRadio(element3)" />

              <DragDrop v-if="verifyConditions(element3) && element3.type === 'inputFile'
                " :label="element3.title" buttonLabel="SELECCIONE SUS ARCHIVOS"
                :fileList="FormData[element3.keyVariable] != null ? FormData[element3.keyVariable] : []"
                v-model="FormData[element3.keyVariable]" :id="element3.keyVariable" :disabled="disableBtn"
                @files-handler="setFiles($event, element3.keyVariable)" maxMB="20" :ref="element3.keyVariable" />



              <a-button v-if="verifyConditions(element3) && element3.type === 'inputBtn'"
                class="align-middle flex p-5 text-[#5C5C5C]" style="width: 203%;height: 52px;"
                v-on:click="addComponent(element3)">

                <a-icon type="plus-circle" theme="filled" style="font-size: 30px;margin-top: -10px;color: #3b82f6;" />

                {{ element3.title }}</a-button>

              <Accordion :open="element3.idHide !== '' ? !!openAccord[element3.keyVariable] : true" v-if="verifyConditions(element3) && element3.type === 'accordion'
                " :header="element3.title" :key="element3.keyVariable" :ref="element3.keyVariable"
                :disable="element3.idHide === '' ? false : !openAccord[element3.keyVariable]"
                :isDelete="element3.isDelete" @deletecomponent="deleteComponent(element3)">

                <div v-for="element4 in element3.contentAccordion" v-bind:key="uniqueId('root-accordion-sub-element')"
                  :class="element4.styles">
                  <h1 v-if="verifyConditions(element4) && element4.type === 'title'">
                    {{ element4.title }}
                  </h1>

                  <h2 v-if="verifyConditions(element4) && element4.type === 'subtitle'
                    " class="mt-10  w-full">
                    {{ element4.title }}
                  </h2>

                  <BaseInput v-if="verifyConditions(element4) && element4.type === 'inputText'" :label="element4.title"
                    :disabled="disableBtn ? true : element4.disabled" :numeric="element4.typeInput === 'number'"
                    @blur="(e, val) => onBlur(e, val, element4.keyVariable)" :value="FormData[element4.keyVariable]"
                    @input="(value) => onInput(element4.keyVariable, value)" :required="element4.required"
                    :ref="element4.keyVariable" />

                  <BaseInput v-if="verifyConditions(element4) && element4.type === 'inputDate'
                    " :label="element4.title" v-model="FormData[element4.keyVariable]"
                    :disabled="disableBtn ? true : element4.disabled" :required="element4.required" type="date"
                    :ref="element4.keyVariable" />

                  <BaseTextarea v-if="verifyConditions(element4) && element4.type === 'textArea'
                    " :label="element4.title" :value="FormData[element4.keyVariable]"
                    @input="(value) => onInput(element4.keyVariable, value)"
                    :disabled="disableBtn ? true : element4.disabled" :required="element4.required"
                    :maxlength="element4.maxlength" :ref="element4.keyVariable" />

                  <BaseSelect v-if="verifyConditions(element4) && element4.type === 'inputSelect'
                    " :label="element4.title" v-model="FormData[element4.keyVariable]"
                    :disabled="disableBtn ? true : element4.disabled" :required="element4.required"
                    @change="(value) => onChangeSelect(element4.onChange, value)"
                    :selectOptions="getOptions(element4.selectOptions)" :ref="element4.keyVariable" />

                  <BaseRadio v-if="verifyConditions(element4) && element4.type === 'inputOption'
                    " :label="element4.title" v-model="FormData[element4.keyVariable]"
                    :disabled="disableBtn ? true : element4.disabled" :required="element4.required"
                    :radioOptions="getOptions(element4.radioOptions)" :ref="element4.keyVariable"
                    :onChangeValue="onChangeRadio(element4)" />

                  <DragDrop v-if="verifyConditions(element4) && element4.type === 'inputFile'
                    " :label="element4.title" buttonLabel="SELECCIONE SUS ARCHIVOS"
                    :fileList="FormData[element4.keyVariable] != null ? FormData[element4.keyVariable] : []"
                    v-model="FormData[element4.keyVariable]" :id="element4.keyVariable" :disabled="disableBtn"
                    @files-handler="setFiles($event, element4.keyVariable)" maxMB="20" :ref="element4.keyVariable" />

                  <a-button v-if="verifyConditions(element4) && element4.type === 'inputBtn'"
                    class="align-middle flex p-5 text-[#5C5C5C]" style="width: 203%;height: 52px;"
                    v-on:click="addComponent(element4)">

                    <a-icon type="plus-circle" theme="filled" style="font-size: 30px;margin-top: -10px;color: #3b82f6;" />

                    {{ element4.title }}</a-button>

                  <Accordion :open="element4.idHide !== '' ? !!openAccord[element4.keyVariable] : true" v-if="verifyConditions(element4) && element4.type === 'accordion'
                    " :header="element4.title" :key="element4.keyVariable" :ref="element4.keyVariable"
                    :disable="element4.idHide === '' ? false : !openAccord[element4.keyVariable]"
                    :isDelete="element4.isDelete" @deletecomponent="deleteComponent(element4)">

                    <div v-for="element5 in element4.contentAccordion"
                      v-bind:key="uniqueId('root-accordion-sub-element-sub-')" :class="element5.styles">
                      <h1 v-if="verifyConditions(element5) && element5.type === 'title'">
                        {{ element5.title }}
                      </h1>

                      <h2 v-if="verifyConditions(element5) && element5.type === 'subtitle'
                        " class="mt-10  w-full">
                        {{ element5.title }}
                      </h2>

                      <BaseInput v-if="verifyConditions(element5) && element5.type === 'inputText'"
                        :label="element5.title" :value="FormData[element5.keyVariable]"
                        @input="(value) => onInput(element5.keyVariable, value)"
                        :numeric="element5.typeInput === 'number'" :disabled="disableBtn ? true : element5.disabled"
                        :required="element5.required" :ref="element5.keyVariable"
                        @blur="(e, val) => onBlur(e, val, element5.keyVariable)" />

                      <BaseInput v-if="verifyConditions(element5) && element5.type === 'inputDate'
                        " :label="element5.title" v-model="FormData[element5.keyVariable]"
                        :disabled="disableBtn ? true : element5.disabled" :required="element5.required" type="date"
                        :ref="element5.keyVariable" />

                      <BaseTextarea v-if="verifyConditions(element5) && element5.type === 'textArea'"
                        :label="element5.title" :value="FormData[element5.keyVariable]"
                        @input="(value) => onInput(element5.keyVariable, value)"
                        :disabled="disableBtn ? true : element5.disabled" :required="element5.required"
                        :maxlength="element5.maxlength" :ref="element5.keyVariable" />

                      <BaseSelect v-if="verifyConditions(element5) && element5.type === 'inputSelect'"
                        :label="element5.title" v-model="FormData[element5.keyVariable]"
                        @change="(value) => onChangeSelect(element5.onChange, value)"
                        :disabled="disableBtn ? true : element5.disabled" :required="element5.required"
                        :selectOptions="getOptions(element5.selectOptions)" :ref="element5.keyVariable" />

                      <BaseRadio v-if="verifyConditions(element5) && element5.type === 'inputOption'
                        " :label="element5.title" v-model="FormData[element5.keyVariable]"
                        :disabled="disableBtn ? true : element5.disabled" :required="element5.required"
                        :radioOptions="getOptions(element5.radioOptions)" :ref="element5.keyVariable"
                        :onChangeValue="onChangeRadio(element5)" />

                      <DragDrop v-if="verifyConditions(element5) && element5.type === 'inputFile'
                        " :label="element5.title" buttonLabel="SELECCIONE SUS ARCHIVOS"
                        :fileList="FormData[element5.keyVariable] != null ? FormData[element5.keyVariable] : []"
                        v-model="FormData[element5.keyVariable]" :id="element5.keyVariable" :disabled="disableBtn"
                        @files-handler="setFiles($event, element5.keyVariable)" maxMB="20" :ref="element5.keyVariable" />

                      <a-button v-if="verifyConditions(element5) && element5.type === 'inputBtn'"
                        class="align-middle flex p-5 text-[#5C5C5C]" style="width: 203%;height: 52px;"
                        v-on:click="addComponent(element5)">

                        <a-icon type="plus-circle" theme="filled"
                          style="font-size: 30px;margin-top: -10px;color: #3b82f6;" />

                        {{ element5.title }}</a-button>

                      <Accordion :open="element5.idHide !== '' ? !!openAccord[element5.keyVariable] : true" v-if="verifyConditions(element5) && element5.type === 'accordion'
                        " :header="element5.title" :key="element5.keyVariable" :ref="element5.keyVariable"
                        :disable="element5.idHide === '' ? false : !openAccord[element5.keyVariable]"
                        :isDelete="element5.isDelete" @deletecomponent="deleteComponent(element5)">

                        <div v-for="element6 in element5.contentAccordion"
                          v-bind:key="uniqueId('root-accordion-sub-element-sub-6-')" :class="element6.styles">
                          <h1 v-if="verifyConditions(element6) && element6.type === 'title'">
                            {{ element6.title }}
                          </h1>

                          <h2 v-if="verifyConditions(element6) && element6.type === 'subtitle'
                            " class="mt-10  w-full">
                            {{ element6.title }}
                          </h2>

                          <BaseInput v-if="verifyConditions(element6) && element6.type === 'inputText'"
                            :label="element6.title" :value="FormData[element6.keyVariable]"
                            @input="(value) => onInput(element6.keyVariable, value)"
                            :disabled="disableBtn ? true : element6.disabled" :required="element6.required"
                            :numeric="element6.typeInput === 'number'" :ref="element6.keyVariable"
                            @blur="(e, val) => onBlur(e, val, element6.keyVariable)" />

                          <BaseInput v-if="verifyConditions(element6) && element6.type === 'inputDate'
                            " :label="element6.title" v-model="FormData[element6.keyVariable]"
                            :disabled="disableBtn ? true : element6.disabled" :required="element6.required" type="date"
                            :ref="element6.keyVariable" />

                          <BaseTextarea v-if="verifyConditions(element6) && element6.type === 'textArea'"
                            :value="FormData[element6.keyVariable]"
                            @input="(value) => onInput(element6.keyVariable, value)" :label="element6.title"
                            :disabled="disableBtn ? true : element6.disabled" :required="element6.required"
                            :maxlength="element6.maxlength" :ref="element6.keyVariable" />

                          <BaseSelect v-if="verifyConditions(element6) && element6.type === 'inputSelect'"
                            :label="element6.title" v-model="FormData[element6.keyVariable]"
                            @change="(value) => onChangeSelect(element6.onChange, value)"
                            :disabled="disableBtn ? true : element6.disabled" :required="element6.required"
                            :selectOptions="getOptions(element6.selectOptions)" :ref="element6.keyVariable" />

                          <BaseRadio v-if="verifyConditions(element6) && element6.type === 'inputOption'
                            " :label="element6.title" v-model="FormData[element6.keyVariable]"
                            :disabled="disableBtn ? true : element6.disabled" :required="element6.required"
                            :radioOptions="getOptions(element6.radioOptions)" :ref="element6.keyVariable"
                            :onChangeValue="onChangeRadio(element6)" />

                          <DragDrop v-if="verifyConditions(element6) && element6.type === 'inputFile'
                            " :label="element6.title" buttonLabel="SELECCIONE SUS ARCHIVOS"
                            :fileList="FormData[element6.keyVariable] != null ? FormData[element6.keyVariable] : []"
                            v-model="FormData[element6.keyVariable]" :id="element6.keyVariable" :disabled="disableBtn"
                            @files-handler="setFiles($event, element6.keyVariable)" maxMB="20"
                            :ref="element6.keyVariable" />

                          <a-button v-if="verifyConditions(element6) && element6.type === 'inputBtn'"
                            class="align-middle flex p-5 text-[#5C5C5C]" style="width: 203%;height: 52px;"
                            v-on:click="addComponent(element6)">

                            <a-icon type="plus-circle" theme="filled"
                              style="font-size: 30px;margin-top: -10px;color: #3b82f6;" />

                            {{ element6.title }}</a-button>

                        </div>
                      </Accordion>

                    </div>
                  </Accordion>

                </div>
              </Accordion>
            </div>
          </Accordion>
        </div>
      </Accordion>
    </div>
    <div class="w-100 d-flex mt-1 items-center justify-center">
      <button v-if="currentStep === 0 && !disableBtn" class="btn btn-primary-outline ms-auto me-1"
        v-on:click="cancelForm">
        CANCELAR
      </button>
      <button v-if="currentStep >= 1 && !disableBtn" class="btn btn-primary-outline ms-auto me-1" v-on:click="backStep">
        VOLVER
      </button>
      <button v-if="currentStep < (totalSteps) && !disableBtn" class="btn btn-primary ms-1 me-auto" v-on:click="nextStep">
        SIGUIENTE
      </button>
      <button class="btn btn-primary-outline me-1 mt-10" v-on:click="cancelDetail"
        v-if="disableBtn && (currentStep) >= 1">
        VOLVER
      </button>
      <button v-if="currentStep === (totalSteps) && !disableBtn" class="btn btn-primary ms-1 me-auto"
        v-on:click="submitForm">
        {{ viewConfig.textButtonSubmit }}
      </button>
    </div>
  </div>
</template>

<style>
.container-dynamic-form {
  padding: 20px;
  display: flex;
  flex-wrap: wrap;
  border: 2px solid #e7e7e7;
  border-radius: 10px;
}

.container-dynamic-form-detail {
  padding: 20px;
  display: flex;
  flex-wrap: wrap;
}

.mt-10 {
  margin-top: 30px;
}

.p-1 {
  padding: 10px;
}

.accordion>div {
  margin-top: 15px;
  width: 100%;
}

.accordion>div>div {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}

.h1 {
  font-weight: bold;
  font-size: 1.7em;
}

.h2 {
  font-weight: bold;
  font-size: 1.4em;
}

.me-50 {
  margin-right: 50%;
}

.ms-1 {
  margin-left: 10px;
}

.mt-1 {
  margin-top: 10px;
}

.mb-1 {
  margin-bottom: 10px;
}

.me-1 {
  margin-right: 10px;
}

.ms-auto {
  margin-left: auto;
}

.me-auto {
  margin-right: auto;
}

.btn {
  border-radius: 20px;
  padding: 10px 70px;
  border: 2px solid;
  font-weight: bold;
  width: 350px;
}

.color-primary,
.color-primary>h1,
.color-primary>h2,
.color-primary>p,
.color-primary>small,
.color-primary>i {
  color: #00549f;
}

.color-gray,
.color-gray>h1,
.color-gray>h2,
.color-gray>p,
.color-gray>small,
.color-gray>i {
  color: #444444;
}

.btn-primary {
  background: #00549f;
  border-color: #00549f;
  color: white;
}

.btn-primary-outline {
  background: white;
  border-color: #00549f;
  color: #00549f;
}

.w-100 {
  width: 100%;
}

.w-50 {
  width: 50%;
}

.d-flex {
  display: flex;
}
</style>

<script>
import Accordion from "@/components/Dashboard/FCO/Accordion.vue";
import mockupRegister from "@/assets/registrationAnnualReport.json";
import mockupReport from "@/assets/mockup.json";
import templateMotivo from "@/assets/template_motivo.json";
import { get, has, uniqueId } from 'lodash'
import moment from "moment";

export default {
  props: ["urlform", "initForm", "disable", "step", "disableBtn", "isReport"],
  components: {
    Accordion,
  },
  data() {
    return {
      files: [],
      activateNext: {},
      totalSteps: 1,
      currentStep: 0,
      FormData: {},
      responseJson: {
        "fecha_reporte": moment().format('DD/MM/YYYY hh:mm A'),
        "responsable": "Carlos Arturo Jaramillo Pérez",
        "tiempo": "Óptimo",
        "estado": "Borrador",
        "steps": {},
        "entidad_vigilada": "",
      },
      viewConfig: {},
      openAccord: {},
      optionsReasons: [],
      optionsProducts: [],
    };
  },
  created() {
    this.currentStep = this.step ?? 0;


    if (this.initForm != null && this.isReport && !this.disableBtn) {
      this.responseJson = { ...Object.assign({}, this.initForm) };
      this.FormData = { ...Object.assign({}, this.initForm['steps'][this.currentStep]) }
    } else {
      this.FormData = { ...Object.assign({}, this.initForm) }
    }

    this.getForm();
  },
  mounted() {
    this.generateJson();
    this.pointChange();
  },
  methods: {
    uniqueId,
    onInput(key, value) {
      this.FormData = Object.assign(this.FormData, { [key]: value })
      const that = this;
      this.$nextTick(() => {
        that.generateJson();
        that.pointChange();
      })
    },
    onBlur(e, val, key) {
      this.FormData[key] = val
      this.$forceUpdate();
    },
    validate(element) {
      if (!this.FormData[element.keyVariable] && element.required) {
        if (this.$refs[element.keyVariable]) {
          this.$refs[element.keyVariable][0].setInvalid(true);
          return false;
        }
      }
      return true;
    },
    getNameById(lista, idBuscado, defaultValue = null) {
      try {
        const elementoEncontrado = lista.find((elemento) => String(elemento.id) === idBuscado);
        if (elementoEncontrado) {
          return elementoEncontrado.name;
        }
      } catch (error) {
      }
      return defaultValue;
    },
    pointChange(element) {
      if (element && !this.disableBtn) {

        if (element.keyVariableHide == "step0-map3-keyperiodoDeRegistro") {
          this.FormData["step0-map3-keyperiodoDeRegistro"] = moment().format('YYYY-MM-DD')
        }
        if (element.keyVariable == 'step2-map1_0-keyLaDcf' && this.FormData['step2-map1_0-keyLaDcf'] == 'No' && this.currentStep == 2 && !this.activateNext['step2-map1_0-keyLaDcf']) {
          this.nextStep();
          this.activateNext['step2-map1_0-keyLaDcf'] = true
        }

        if (element.keyVariable == 'step3-map1_2-keyLaDcf' && this.FormData['step3-map1_2-keyLaDcf'] == 'No' && this.currentStep == 3 && !this.activateNext['step3-map1_2-keyLaDcf']) {
          this.nextStep();
          this.activateNext['step3-map1_2-keyLaDcf'] = true
        }

        if (element.keyVariable == 'step3.3.0-map1_7_0-keyLaDcf' && this.FormData['step3.3.0-map1_7_0-keyLaDcf'] == 'No' && this.currentStep == 3 && !this.activateNext['step3.3.0-map1_7_0-keyLaDcf']) {
          this.nextStep();
          this.activateNext['step3.3.0-map1_7_0-keyLaDcf'] = true
        }

        if (element.keyVariable == 'step1-map1_3_18-keyElDcf' && this.FormData['step1-map1_3_18-keyElDcf'] == 'No' && this.currentStep == 1 && !this.activateNext['step1-map1_3_18-keyElDcf']) {
          this.nextStep();
          this.activateNext['step1-map1_3_18-keyElDcf'] = true
        }

        if (element.keyVariable == 'step1-map1_3.2.4_18_1-keyElDcf' && this.FormData['step1-map1_3.2.4_18_1-keyElDcf'] == 'No' && this.currentStep == 1 && !this.activateNext['step1-map1_3.2.4_18_1-keyElDcf']) {
          this.nextStep();
          this.activateNext['step1-map1_3.2.4_18_1-keyElDcf'] = true
        }


      }


      if (this.FormData['step0-map0-keyseleccionaEntidadVigilada'] && this.currentStep == 0) {
        this.responseJson["cod_entidad_vigilada"] = this.FormData['step0-map0-keyseleccionaEntidadVigilada']
        this.$set(this.FormData, 'step0-map1-keycodigoDeLa', this.FormData['step0-map0-keyseleccionaEntidadVigilada'])
        this.responseJson["entidad_vigilada"] = this.getNameById(this.formOptions.optionsCompanies, this.FormData['step0-map0-keyseleccionaEntidadVigilada']);
      }
    },
    async generateTemplateMotivo() {

      const keyMotivoProducto = Math.random().toString(16).slice(2)
      const keyProducto = Math.random().toString(16).slice(2)
      const keyTextA = Math.random().toString(16).slice(2)
      const keyMotivo = Math.random().toString(16).slice(2)
      const keyQuejas = Math.random().toString(16).slice(2)
      const keyQuejas1 = Math.random().toString(16).slice(2)

      templateMotivo["keyVariable"] = keyMotivoProducto;
      console.log('producto', keyMotivoProducto)
      templateMotivo["contentAccordion"][0]["keyVariable"] = keyProducto;
      templateMotivo["contentAccordion"][1]["keyVariable"] = keyQuejas;
      templateMotivo["contentAccordion"][2]["keyVariable"] = keyTextA;
      templateMotivo["contentAccordion"][2]["conditionVisible"] = [{
        "keyTarget": keyProducto,
        "objetiveValues": ["0"]
      }]
      templateMotivo["contentAccordion"][3]["keyVariable"] = keyMotivo;
      templateMotivo["contentAccordion"][4]["keyVariable"] = keyQuejas1;

      return templateMotivo;
    },
    async addComponent(element) {
      let newData = has(this.viewConfig.steps[this.currentStep], element.addComponentKey)

      if (newData) {

        let template = await this.generateTemplateMotivo();

        template["addComponentKey"] = element.addComponentKey;
        
        const arrayActual = get(this.viewConfig.steps[this.currentStep], element.addComponentKey, []);

        let index = arrayActual.findIndex(x => x === element)

        arrayActual.splice(index, 0, structuredClone(template))

        this.$set(this.viewConfig.steps[this.currentStep], element.addComponentKey, arrayActual);

      }
    },
    deleteComponent(element) {

      const arrayActual = get(this.viewConfig.steps[this.currentStep], element.addComponentKey, []);

      let index = arrayActual.findIndex(x => x === element)

      arrayActual.splice(index, 1)
      const keyProducto = element.contentAccordion[0]["keyVariable"];
      const keyQuejas = element.contentAccordion[1]["keyVariable"];
      const keyTextA = element.contentAccordion[2]["keyVariable"];
      const keyMotivo = element.contentAccordion[3]["keyVariable"];
      const keyQuejas1 = element.contentAccordion[4]["keyVariable"];

      delete this.FormData[keyProducto];
      delete this.FormData[keyQuejas];
      delete this.FormData[keyTextA];
      delete this.FormData[keyMotivo];
      delete this.FormData[keyQuejas1];

      this.$set(this.viewConfig.steps[this.currentStep], element.addComponentKey, arrayActual);
    },
    validateForm() {
      let actualStep = (this.currentStep).toString();
      let goToNext = [];

      for (let index = 0; index < this.viewConfig.steps[actualStep].length; index++) {
        let element = this.viewConfig.steps[actualStep][index];
        if (element.contentAccordion) {
          for (let index = 0; index < element.contentAccordion.length; index++) {
            let element2 = element.contentAccordion[index];
            if (element2.contentAccordion) {
              for (let index = 0; index < element2.contentAccordion.length; index++) {
                let element3 = element2.contentAccordion[index];
                if (element3.contentAccordion) {
                  for (let index = 0; index < element3.contentAccordion.length; index++) {
                    let element4 = element3.contentAccordion[index];
                    if (element4.contentAccordion) {
                      for (let index = 0; index < element4.contentAccordion.length; index++) {
                        let element5 = element4.contentAccordion[index];
                        if (element5.contentAccordion) {
                          for (let index = 0; index < element5.contentAccordion.length; index++) {
                            let element6 = element5.contentAccordion[index];
                            const isvalid = this.validate(element6);
                            goToNext.push(isvalid)
                          }
                        } else {
                          const isvalid = this.validate(element5);
                          goToNext.push(isvalid)
                        }
                      }
                    } else {
                      const isvalid = this.validate(element4);
                      goToNext.push(isvalid)
                    }
                  }
                } else {
                  const isvalid = this.validate(element3);
                  goToNext.push(isvalid)
                }
              }
            } else {
              const isvalid = this.validate(element2);
              goToNext.push(isvalid)
            }
          }
        } else {
          const isvalid = this.validate(element);
          goToNext.push(isvalid)
        }
      }

      let isToNext = goToNext.every((value) => {
        return value === true;
      });

      return isToNext;
    },
    onChangeRadio(element) {
      const that = this;

      this.pointChange(element);

      this.$nextTick(() => {
        that.generateJson();
      })
      this.openAccord[element.keyVariableHide] = this.open(element)
    },
    open(element) {
      return (
        !!this.FormData[element.keyVariable]
        && this.FormData[element.keyVariable] !== element.idHide
      )
    },
    generateJson() {
      let actualStep = this.currentStep;

      this.FormData['complete'] = false;


      const lengthFormData = Object.keys(this.FormData).length - 1;

      if (this.viewConfig.steps[actualStep].length === lengthFormData) {
        this.FormData['complete'] = true;
      }

      let convertDataForm = JSON.parse(JSON.stringify(this.FormData))

      this.responseJson['steps'][actualStep] = convertDataForm

      localStorage.setItem(
        "DynamicForm",
        JSON.stringify(this.responseJson)
      );
    },
    async getForm() {
      let data = {};
      if (this.isReport) {

        data = mockupReport;
      } else {
        data = mockupRegister;

      }

      /* if (this.urlform.includes("http")) {
         data = await this.fetchJsonData(this.urlform);
       } else {
 
         let { data: dataPivot, error } = await this.$api.getFormRequest(
           `?id=${this.urlform}`
         );
         data = dataPivot;
 
 
         if (error) {
           return;
         }
       }*/

      function formatearSteps(objeto) {
        // Verifica si el objeto tiene una clave llamada "steps"
        if ("steps" in objeto) {
          const steps = objeto["steps"];
          // Verifica si "steps" es un objeto con claves numéricas
          if (
            typeof steps === "object" &&
            !Array.isArray(steps) &&
            Object.keys(steps).every((key) => !isNaN(Number(key)))
          ) {
            // Convierte "steps" en un array de arrays
            objeto["steps"] = Object.values(steps);
          }
        }
        return objeto;
      }

      const dataKeys = Object.keys(data);
      const dataValues = Object.values(data);


      const isFirebaseFormat = dataKeys.length === 1;


      const dataConfig = isFirebaseFormat
        ? formatearSteps(dataValues[0])
        : data;



      this.viewConfig = {
        ...this.viewConfig,
        ...dataConfig,
      };

      this.totalSteps = this.viewConfig.steps.length - 1;
    },
    async fetchJsonData(url) {
      try {
        const response = await fetch(url);


        if (!response.ok) {
          throw new Error(
            `Error en la solicitud: ${response.status} ${response.statusText}`
          );
        }

        const data = await response.json();



        return data;
      } catch (error) {
        return {}; // Retorna un objeto vacío en caso de error
      }
    },
    verifyConditions(obj) {
      if (obj && obj.conditionVisible) {
        return this.todosSonTrue(
          obj.conditionVisible.map((item) => {
            return this.verificarCoincidencia(
              this.FormData,
              item.keyTarget,
              item.objetiveValues
            );
          })
        );
      } else {
        return true;
      }
    },
    todosSonTrue(array) {
      return array.every(function (element) {
        return element === true;
      });
    },
    verificarCoincidencia(objeto, clave, array) {
      // Verificar si la clave existe en el objeto
      if (objeto.hasOwnProperty(clave)) {
        // Verificar si el valor de la clave coincide con algún elemento del array
        if (array.includes(objeto[clave])) {
          return true;
        }
      }
      return false;
    },
    nextStep() {

      let isToNext = this.validateForm();


      if (isToNext) {
        this.generateJson()
        this.pointChange()

        this.FormData = {};
        this.files = []

        localStorage.setItem(
          "DynamicForm",
          JSON.stringify(this.responseJson)
        );


        this.submitForm()

        this.currentStep++;

        if (this.responseJson['steps'][this.currentStep]) {
          this.FormData = Object.assign({}, this.FormData, this.responseJson['steps'][this.currentStep]);
        }
      }

    },
    backStep() {
      this.currentStep--
      this.FormData = Object.assign({}, this.FormData, this.responseJson['steps'][this.currentStep]);
    },
    cancelForm() {
      localStorage.removeItem('DynamicFormID');
      localStorage.removeItem('DynamicForm');
      this.$emit("methodCancel", 1);
    },
    cancelDetail() {
      this.$emit("methodCancelDetail");
    },
    submitForm() {

      if ((this.currentStep) === 0 && this.initForm === null) {
        this.$emit("methodSubmit", this.responseJson);
      }

      if ((this.viewConfig.steps.length - 1) === (this.currentStep)) {

        this.$emit("saveDraft");

        if (this.initForm != null && this.isReport) {
          this.$notification.success({
            message: "Notificación",
            description: "Informe actualizado de forma exitosa",
          });

        } else {
          this.$notification.success({
            message: "Notificación",
            description: "Informe creado de forma exitosa",
          });
        }

        localStorage.removeItem('DynamicFormID');
        localStorage.removeItem('DynamicForm');

        this.cancelForm()

      }

      if ((this.viewConfig.steps.length - 1) !== this.currentStep && (this.currentStep) !== 0) {
        this.$emit("saveDraft");
      }

    },
    setFiles(files, keyVariable) {
      this.FormData[keyVariable] = files;
      this.$forceUpdate();
      this.$emit("addAnexo", { 'files': files, 'step': this.currentStep, });

    },
    getOptions(key) {
      if (Array.isArray(key)) {
        return key;
      } else {
        switch (key) {
          case "optionsReasons":
            return this.optionsReasons
          case "optionsProducts":
            return this.optionsProducts
          default:
            return this.formOptions[key];
        }
      }
    },
    async onChangeSelect(method, value) {
      switch (method) {
        case "setProductAndReasons":
          if (!value) {
            break;
          }
          let optionsReasons = await this.$store.dispatch(
            "form/loadReasonsOptions",
            { company: value }
          );
          let optionsProducts = await this.$store.dispatch(
            "form/loadProductsOptions",
            { company: value }
          );

          const otherOption = {
            "id": 0,
            "name": "Otra"
          }

          optionsProducts.push(otherOption);

          this.optionsReasons = optionsReasons;
          this.optionsProducts = optionsProducts;
          break;
      }
    }
  },
  computed: {
    formOptions: function () {
      return this.$store.state.form;
    },
    getCurrentStep() {
      return this.viewConfig.steps[this.currentStep];
    },
  },
  watch: {
    currentStep() {
      this.generateJson()
      this.pointChange()
    }
  }
};
</script>